// extracted by mini-css-extract-plugin
export default {"root":"QXGZ4eAcQoxRCilmqqZo","text":"oZJx52Qe9vNlMfjUFPJp","min":"vf9qQBJmKMJZ2KST3VxV oZJx52Qe9vNlMfjUFPJp","max":"DF95SS0JPbdbbTXCLH7O oZJx52Qe9vNlMfjUFPJp"};